<script>
  import StepOptions from "../Popups/StepOptions.svelte";
  import {External, M} from "../../external";

  export let onAdd;
  export let order;
  export let length;
  export let automation;
  export let automationSave;

  let onClick = function () {
    let component;

    External.Tools.showWindow({
      title: M.ADD_AUTOMATION_STEP,
      icon: External.Popup.ICON_EDIT,
      width: 500,
      customClass: "add-member-dialog",
      isModal: false,
      withDarkBackground: true,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: '<div class="popup-widget-wrapper bind-component"></div>',
      action: {
        onShow: function (popup, context) {
          component = new StepOptions({
            target: context.find(".bind-component")[0],
            props: {
              add: onAdd,
              parentPopup: popup,
              order: order,
              length: length,
              automation: automation,
              automationSave: automationSave
            }
          });
        },
        onHide: function () {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      }
    });
  };
</script>

<div class="flex justify-center">
  <a on:click={onClick} class="automation-step-add rounded-effect"></a>
</div>
